import {
	renderCertificateFromJSON,
	downloadCertificate,
	downloadCertificateAsPDF,
} from '../backend/builder/utils/certificate-download';

( function( $ ) {
	let $html, el_lp_data_config_cer, el_show_cer_popup_first,
		el_form_certificate_button, el_popup_cert, el_single_certificate,
		el_social_cert, el_need_upload_cert_img_to_server;

	let el_form_lp_cert_add_to_cart_woo;
	let el_form_lp_cert_add_to_cart_lp;

	window.LP_Certificate = function( el, options ) {
		const $el = $( el );
		let canvas = null;

		let el_certificate_actions, el_download;
		let name_file_download = 'certificate';

		async function init() {
			el_certificate_actions = $( '.certificate-actions' );

			try {
				const canvasEl = $el.find( 'canvas' ).get( 0 );
				if ( ! canvasEl ) {
					console.error( 'LP_Certificate: canvas element not found' );
					return;
				}

				const result = await renderCertificateFromJSON( options, { canvasEl } );
				canvas = result.canvas;

				$el.addClass( 'canvas-preview-ready' );

				onReady();
			} catch ( e ) {
				console.error( 'LP_Certificate init error:', e );
			}

			$( document ).on( 'click', '[data-cert="' + $el.attr( 'id' ) + '"]', function( e ) {
				e.preventDefault();
				download();
			} );
		}

		function onReady() {
			if ( el_need_upload_cert_img_to_server.length ) {
				saveImageToServer();
			}

			if ( el_certificate_actions.length ) {
				el_download = el_certificate_actions.find( '.download' );
			}

			$el.find( '.lp-data-config-cer' ).addClass( 'loaded' );

			$( document ).triggerHandler( 'learn-press/certificates/loaded' );
		}

		function download() {
			if ( ! canvas || ! el_download || ! el_download.length ) {
				return;
			}

			if ( undefined !== options.name ) {
				name_file_download = options.name;
			}

			const downloadType = el_download.data( 'type-download' );

			if ( downloadType === 'pdf' ) {
				downloadCertificateAsPDF( canvas, {
					filename: name_file_download + '.pdf',
					multiplier: 2,
				} );
			} else {
				downloadCertificate( canvas, {
					filename: name_file_download + '.png',
					format: 'png',
					quality: 1,
					multiplier: 2,
				} );
			}
		}

		function saveImageToServer() {
			if ( ! canvas ) {
				return;
			}

			const data = {
				action: 'lpCertCreateImage',
				data64: canvas.toDataURL( { format: 'png', quality: 1 } ),
				name_image: options.key_cer,
			};

			$.ajax( {
				url: localize_lp_cer_js.url_ajax,
				data,
				method: 'post',
				dataType: 'json',
				beforeSend() {
					el_certificate_actions.append( '<li class="fa fa-spinner">Loading share social...</li>' );
				},
				success( rs ) {
					if ( rs.code === 1 ) {
						$.each( el_social_cert, function() {
							const elLink = $( this ).find( 'a' );
							const hrefShare = elLink.attr( 'href' );
							const url_cert_share = hrefShare + rs.url_cert;
							elLink.attr( 'href', url_cert_share );
						} );

						el_social_cert.show();
					}
				},
				complete() {
					el_certificate_actions.find( '.fa-spinner' ).remove();
				},
				error( e ) {
					console.log( e );
				},
			} );
		}

		init();
	};

	function getElements() {
		$html = $( 'html, body' );
		el_lp_data_config_cer = $( '.lp-data-config-cer' );
		el_show_cer_popup_first = $( 'input[name=f_auto_show_cer_popup_first]' );
		el_form_certificate_button = $( 'form[name="certificate-form-button"]' );
		el_popup_cert = $( '#certificate-popup' );
		el_single_certificate = $( '.single-certificate-content' );
		el_social_cert = $( '.share-social-cert' );
		el_need_upload_cert_img_to_server = $( 'input[name=need_upload_cert_img_to_server]' );

		el_form_lp_cert_add_to_cart_woo = $( 'form[name=form-lp-cert-add-to-cart-woo]' );
		el_form_lp_cert_add_to_cart_lp = $( 'form[name=form-lp-cert-purchase]' );
	}

	function popupCer() {
		if ( el_popup_cert.length ) {
			let isReady = false;

			function close() {
				el_popup_cert.fadeOut( function() {
					$html.css( 'overflow', 'auto' );
				} );
			}

			function open() {
				if ( ! isReady ) {
					return;
				}
				$html.css( 'overflow', 'hidden' );
				el_popup_cert.fadeIn();
			}

			el_form_certificate_button.on( 'submit', function( e ) {
				e.preventDefault();
				open();
			} );

			$( document ).on( 'learn-press/certificates/loaded', function() {
				isReady = true;
				el_popup_cert.addClass( 'ready' ).hide();

				$html
					.on( 'keyup', function( e ) {
						if ( e.keyCode === 27 ) {
							close();
						}
					} )
					.on( 'click', '.close-popup', function( e ) {
						close();
						e.preventDefault();
					} );

				if ( el_show_cer_popup_first.length ) {
					open();
				}
			} );
		}
	}

	function addCertToCartWoo( form ) {
		const lang = lpData.urlParams.lang ? `?lang=${ lpData.urlParams.lang }` : '';
		const btn = form.querySelector( '.btn-add-cert-to-cart-woo' );
		const formData = new FormData( form );
		const data = Object.fromEntries( formData.entries() );
		data.action = 'lp_cert_add_to_cart_woo';

		$.ajax( {
			url: localize_lp_cer_js.url_ajax + lang,
			data,
			method: 'post',
			beforeSend() {
				btn.classList.add( 'loading' );
			},
			success( rs ) {
				if ( rs.code === 1 ) {
					if ( undefined !== rs.redirect_to ) {
						window.location.replace( rs.redirect_to );
					} else {
						form.closest( '.wrapper-lp-cert-add-to-cart-woo' ).insertAdjacentHTML( 'beforeend', rs.button_view_cart );
						form.remove();
					}
				} else {
					alert( rs.message );
				}
			},
			error( e ) {
				console.log( e );
			},
			complete() {
				btn.classList.remove( 'loading' );
			},
		} );
	}

	function addCertToCartLP( form ) {
		let message = '';
		let status = '';
		const formData = new FormData( form );
		const data = Object.fromEntries( formData.entries() );
		const btn = form.querySelector( '.btn-purchase-certificate' );
		btn.classList.add( 'loading' );

		const newElMessage = document.createElement( 'div' );
		newElMessage.classList.add( 'learn-press-message' );

		wp.apiFetch( {
			path: '/lp/v1/certificate/purchase',
			method: 'POST',
			data,
		} ).then( ( res ) => {
			const { data } = res;
			status = res.status;
			message = res.message;

			newElMessage.classList.add( status );
			newElMessage.innerHTML = message;
			form.insertAdjacentElement( 'beforeend', newElMessage );

			if ( undefined !== status && status === 'success' ) {
				if ( data.redirect ) {
					setTimeout( function() {
						window.location.href = data.redirect;
					}, 800 );
				}
			}
		} ).catch( ( err ) => {
			newElMessage.classList.add( 'error' );
			newElMessage.innerHTML = err.message;
			form.insertAdjacentElement( 'beforeend', newElMessage );
		} ).then( () => {
			btn.remove();
		} );
	}

	$( document ).ready( function() {
		getElements();
		el_social_cert.hide();

		if ( ! el_show_cer_popup_first.length ) {
			el_form_certificate_button.css( 'display', 'inline-block' );
		}

		if ( el_lp_data_config_cer.length ) {
			try {
				$.each( el_lp_data_config_cer, function() {
					const data_config_cer = JSON.parse( $( this ).val() ) || {};

					$( this ).val( '' );
					const id_div_parent = '#' + $( this ).closest( 'div' ).attr( 'id' );

					LP_Certificate( id_div_parent, data_config_cer );
				} );
			} catch ( e ) {
				console.log( e );
			}
		}

		popupCer();

		document.addEventListener( 'submit', function( e ) {
			const el = e.target;

			if ( el.getAttribute( 'name' ) === 'form-lp-cert-purchase' ) {
				e.preventDefault();
				addCertToCartLP( el );
			} else if ( el.getAttribute( 'name' ) === 'form-lp-cert-add-to-cart-woo' ) {
				e.preventDefault();
				addCertToCartWoo( el );
			}
		} );
	} );
}( jQuery ) );
